import React, { Component } from 'react';
import classnams from 'classnames';
import PropTypes from 'prop-types';
import { getMarketingAward } from '../../../service/chat-service';

import styles from './myreawrd.module.less';

import img from '../images/rewardInfo.png';
import tools from '../../../utils/tools';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

class MyReward extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //   recommendList: [],
    //   totalAmount: 0,
      myReward: {},
    };
  }

  componentDidMount() {
    window.document.title = '我的奖励';

    this.initMarketingAward();
  }

  initMarketingAward = async () => {
    const snsapiBaseOpenId = localStorage.getItem('snsapiBaseOpenId');

    try {
      const { code, data } = await getMarketingAward(snsapiBaseOpenId);
      if (code === 10000) this.setState({ myReward: data });
    } catch (e) {
      // console.log(e);
    }
  }

  jumpProductDetailPage = (item) => {
    const { history } = this.props;
    history.push(`/rewardRule?productId=${item.product_id}&shareUserId=${item.sourceUrl}`);
  }

  /*
   * 参与转发
   */
  renderRewardRed = () => {
    const { myReward } = this.state;
    const { marketingList } = myReward;

    if (JSON.stringify(marketingList) !== '[]' && marketingList) {
      return marketingList.map((item) => (
        <div key={item.name} className={styles.redList}>
          <div className={styles.redItem}>
            <i>·</i>
            「
            {item.name}
            」
          </div>
          <div className={styles.redDateInfo}>
            <div style={{ color: '#cbcbcb', fontSize: '15px' }}>
              截止时间：
              {tools.formatUnixtimestamp(item.endDate)}
            </div>
            <div style={{ color: '#FF6516', fontSize: '15px' }}>
              已集齐红包
              {item.userBalance / 100}
              元
            </div>
          </div>
        </div>
      ));
    }
    return true;
  }

  renderTaskList = () => {
    const { myReward } = this.state;
    const { recommendList } = myReward;
    if (JSON.stringify(recommendList) !== '[]' && recommendList) {
      return recommendList.map((item) => (
        <div
          key={item.name}
          className={classnams(styles.redList, styles.redListBorder)}
          onClick={this.jumpProductDetailPage}
          role="button"
          tabIndex={0}
        >
          <img src={item.img2} alt="headImg" />
          <div style={{ marginLeft: '50px' }}>
            <div className={styles.redItem}>
              <i>·</i>
              「
              {item.name}
              」
            </div>
            <div className={styles.redDateInfo}>
              <div style={{ color: '#cbcbcb', fontSize: '13px' }}>
                截止时间：
                {tools.formatUnixtimestamp(item.endDate)}
              </div>
              <div style={{ color: '#FF6516', fontSize: '13px' }}>
                已集齐红包
                {item.userBalance / 100}
                元
              </div>
            </div>
          </div>
        </div>
      ));
    }
    return true;
  };

  jumpPage = () => {
    const { history } = this.props;
    history.push('/forwardReward');
  }

  render() {
    const { myReward } = this.state;
    return (
      <div className={styles.containerBox}>
        <div className={styles.header}>
          <div className={styles.title}>奖金钱包（元）</div>
          <div className={styles.amount}>{myReward.totalAmount / 100}</div>
        </div>

        <div className={styles.forwardBox}>
          <div className={styles.forwardBox_header}>
            <div>参与转发</div>
            <div className={styles.viewAll} onClick={this.jumpPage} role="button" tabIndex={0}>
              查看全部
              {' '}
              <i className={styles.right} />
            </div>
          </div>

          <div style={{ borderRadius: '6px' }}>
            {this.renderRewardRed()}
          </div>
        </div>

        <div className={styles.forwardBox} style={{ padding: '0', boxShadow: 'none', display: 'none' }}>
          <div className={styles.moreTask}>更多营销任务</div>
          {this.renderTaskList()}
        </div>
      </div>
    );
  }
}

MyReward.propTypes = propTypes;
MyReward.defaultProps = defaultProps;

export default MyReward;
